




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import vue from 'vue';
import { colors } from '@/config';
import { highchartsSpacing } from '@/utils/chartPresentationSizing';

More(Highcharts);

@Component({components: {Chart}})
export default class ProfitLoss extends Vue {
    @Prop() readonly profitloss!: any;
    @Prop() dark!: boolean;
    @Prop() containerWidth: any;
    @Prop() currentLanguage: any;

    chartOptions: any = {};

    update() {
      this.$nextTick(() => {
        const chart = this.$refs.chart as any;
        if (chart && chart.chart) {
          chart.chart.reflow();
        }
      });

      this.chartOptions = {
        chart: {
            type: 'waterfall',
            backgroundColor: 'transparent',
            ...highchartsSpacing(this.containerWidth),
        },

        credits: {
            enabled: false,
        },

        title: {
            text: '',
        },


        xAxis: {
            type: 'category',
            labels: {
                autoRotation: [0],
                // rotation: [-25],
                staggerLines: 1,
                padding: this.transformPx(10),
                style: {
                    fontSize: '1cqw',
                    textOverflow: 'none',
                    whiteSpace: 'normal',
                    color: this.dark ? colors.Light : colors.Black,
                },
            },
            plotLines: [{
                color: this.dark ? colors.LightGrey : colors.DarkGrey,
                dashStyle: 'dot',
                value: 1.5,
                width: this.transformPx(2),
                label: {
                    text: this.currentLanguage === 'en' ? 'Gross profit/loss' : Vue.prototype.$t('Bruttoresultat'),
                    style: {
                        fontSize: '0.875cqw',
                        color: this.dark ? colors.Light : colors.DarkGrey,
                    },
                },
            },
            {
                color: this.dark ? colors.LightGrey : colors.DarkGrey,
                dashStyle: 'dot',
                value: 3.5,
                width: this.transformPx(2),
                label: {
                    text: this.currentLanguage === 'en' ? 'Operating profit/loss' : Vue.prototype.$t('Rörelseresultat'),
                    style: {
                        fontSize: '0.875cqw',
                        color: this.dark ? colors.Light : colors.DarkGrey,
                    },
                },
            }],
            lineColor: this.dark ? colors.Black : colors.LightGrey,
        },

        yAxis: {
            title: {
                text: '',
            },
            labels: {
                style: {
                    fontSize: this.dark ? '1cqw' : '1cqw',
                    color: this.dark ? colors.Light : colors.Black,
                },
                formatter() { return (vue as any).options.filters.KR((this as any).value); },
            },
            tickPixelInterval: this.dark ? this.transformPx(200) : 150,
            gridLineColor: this.dark ? colors.Black : colors.LightGrey,
            plotLines: [{
                color: colors.Black,
                width: this.dark ? this.transformPx(3) : 2,
                value: 0,
                zIndex: 2,
            }],
        },

        legend: {
            enabled: false,
        },

        tooltip: {
            // headerFormat: '',
            // pointFormat: '<span>{point.subname}: <b>{point.y:,.0f} tkr</b></span>',
            formatter() {
              return (this as any).point.subname + ' ' + ' ' + (vue as any).options.filters.TKR((this as any).point.y);
            },
            style: {
                fontSize: '1.5cqw',
                color: this.dark ? colors.Light : colors.Black,
            },
            backgroundColor: this.dark ? colors.Dark : colors.Light,
        },

        series: this.getSeries(),
      };
    }
    mounted() {
      this.update();
    }

    @Watch('profitloss', {immediate: false, deep: true})
    profitlossChanged() {
      this.update();
    }

    @Watch('containerWidth', {immediate: false, deep: true})
    containerWidthChanged() {
      this.update();
    }

    getSeries() {
        return [{
            upColor: colors.DarkGrey,
            color: colors.Tertiary,
            lineColor: this.dark ? colors.Black : colors.DarkGrey,
            borderColor: this.dark ? colors.Black : colors.DarkGrey,
            data: [{
                name: this.currentLanguage === 'en' ? 'Income' : Vue.prototype.$t('Intäkter'),
                subname: this.currentLanguage === 'en' ? 'Net sales' : Vue.prototype.$t('Nettoomsättning'),
                y: this.profitloss.A,
                color: this.dark ? colors.Secondary : colors.Primary,
            }, {
                name: this.currentLanguage === 'en' ? 'Income' : Vue.prototype.$t('Intäkter'),
                subname: this.currentLanguage === 'en' ? 'Other incomes' : Vue.prototype.$t('Övriga rörelseintäkter'),
                y: this.profitloss.B,
            }, {
                name: this.currentLanguage === 'en' ? 'Goods & material' : Vue.prototype.$t('Varor & material'),
                subname: this.currentLanguage === 'en' ? 'Cost of goods & material' : Vue.prototype.$t('Kostnader för varor & material'),
                y: this.profitloss.D,
            }, {
                name: this.currentLanguage === 'en' ? 'Operating costs' : Vue.prototype.$t('Drifts-kostnader'),
                subname: this.currentLanguage === 'en' ? 'Other external costs' : Vue.prototype.$t('Övriga externa kostnader'),
                y: this.profitloss.F,
            }, {
                name: this.currentLanguage === 'en' ? 'Operating costs' : Vue.prototype.$t('Drifts-kostnader'),
                subname: this.currentLanguage === 'en' ? 'Cost of personell' : Vue.prototype.$t('Personalkostnader'),
                y: this.profitloss.G,
            }, {
                name: this.currentLanguage === 'en' ? 'Operating costs' : Vue.prototype.$t('Drifts-kostnader'),
                subname: this.currentLanguage === 'en' ? 'Other operating costs' : Vue.prototype.$t('Övriga rörelsekostnader'),
                y: this.profitloss.H,
            }, {
                name: this.currentLanguage === 'en' ? 'Depreciation' : Vue.prototype.$t('Av- och ned-skrivningar'),
                subname: this.currentLanguage === 'en' ? 'Depreciation' : Vue.prototype.$t('Av- och nedskrivningar'),
                y: this.profitloss.J,
            }, {
                name: this.currentLanguage === 'en' ? 'Financial' : Vue.prototype.$t('Finansiella poster'),
                subname: this.currentLanguage === 'en' ? 'Financial posts' : Vue.prototype.$t('Finansiella poster'),
                y: this.profitloss.L + this.profitloss.M,
                color: this.profitloss.L + this.profitloss.M > 0 ? colors.DarkGrey : colors.LightGrey,
            }, {
                name: this.currentLanguage === 'en' ? 'Accrual fund' : Vue.prototype.$t('Boksluts-disp.'),
                subname: this.currentLanguage === 'en' ? 'Accrual fund' : Vue.prototype.$t('Bokslutsdispositioner'),
                y: this.profitloss.O,
                color: this.profitloss.O > 0 ? colors.DarkGrey : colors.LightGrey,
            }, {
                name: this.currentLanguage === 'en' ? 'Tax' : Vue.prototype.$t('Skatt'),
                subname: this.currentLanguage === 'en' ? 'This years tax' : Vue.prototype.$t('Årets skatt'),
                y: this.profitloss.Q,
                color: this.profitloss.Q > 0 ? colors.DarkGrey : colors.LightGrey,
            }, {
                name: this.currentLanguage === 'en' ? 'Net profit/loss' : Vue.prototype.$t('Årets resultat'),
                subname: this.currentLanguage === 'en' ? 'Net profit/loss' : Vue.prototype.$t('Årets resultat'),
                isSum: true,
                color: this.profitloss.R > 0 ? colors.Positive : colors.Negative,
            },
            ],

            pointPadding: 0,
        }];
    }

    transformPx(value: any) {
      if ( value * (this.containerWidth / 1920) < 1 ) {
        return 1;
      }
      return value * (this.containerWidth / 1920);
    }

}
